import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
import { useTestIdAttribute, } from '../../hooks/useTestIdAttribute';
import { SPINNER_SIZE_MAP } from './spinnerConst';
const spinAnimation = {
    from: {
        transform: 'rotate(0deg)',
    },
    to: {
        transform: 'rotate(360deg)',
    },
};
const StyledSpinner = styled('div', (p) => ({
    width: SPINNER_SIZE_MAP[p.$size],
    height: SPINNER_SIZE_MAP[p.$size],
    borderWidth: sizes.spinner.borderWidth,
    borderStyle: 'solid',
    borderColor: `${p.$color} transparent transparent transparent`,
    borderRadius: '50%',
    animationName: spinAnimation,
    animationDuration: '1.2s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'cubic-bezier(0.5, 0, 0.5, 1)',
}));
export const Spinner = ({ size = 'medium', spinnerColorOverride, testId, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    const color = spinnerColorOverride ?? staticColors.spinner;
    return _jsx(StyledSpinner, { $size: size, $color: color, ...testIdAttribute });
};
